import { Property } from "@/types/property";

interface PropDetailsAdditionalInfoProps {
  property: Property;
}

const PropDetailsAdditionalInfo = ({
  property,
}: PropDetailsAdditionalInfoProps) => {
  return (
    <>
      {/* ADDITIONAL INFO */}
      {property?.additional_info && (
        <div className="mt-6">
          <h3 className="font-bold text-base text-main-900 mb-3">
            Additional Information
          </h3>
          <p className="text-sm text-grey-7 whitespace-pre-line">
            {property.additional_info}
          </p>
        </div>
      )}

      {/* SHORTLET: NUMBER OF DAYS */}
      {property?.listing_type === "shortlet" && property?.number_of_days && (
        <div className="mt-4 text-sm text-grey-7">
          <span className="font-bold text-main-900">Duration:</span>{" "}
          {property.number_of_days}{" "}
          {property.number_of_days === 1 ? "day" : "days"}
        </div>
      )}

      {/* LAND: NUMBER OF PLOTS */}
      {property?.listing_type === "land" && property?.number_of_plots && (
        <div className="mt-4 text-sm text-grey-7">
          {property.number_of_plots}{" "}
          <span className="font-bold text-main-900"> Sqm</span>
        </div>
      )}
    </>
  );
};

export default PropDetailsAdditionalInfo;
